import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import './FullProduct.css';

// --- BULK IMPORTS ---
import img1 from "../../../assets/Product/img1.jpeg";
import img2 from "../../../assets/Product/img2.JPG";
import img3 from "../../../assets/Product/img3.JPG";
import img4 from "../../../assets/Product/img4.JPG";
import img5 from "../../../assets/Product/img5.JPG";
import img6 from "../../../assets/Product/img6.JPG";
import img7 from "../../../assets/Product/img7.JPG";
import img8 from "../../../assets/Product/img8.JPG";
import img9 from "../../../assets/Product/img9.JPG";
import img10 from "../../../assets/Product/img10.JPG";
import img11 from "../../../assets/Product/img11.JPG";
import img12 from "../../../assets/Product/img12.JPG";
import img13 from "../../../assets/Product/img13.JPG";
import img14 from "../../../assets/Product/img14.JPG";
import img15 from "../../../assets/Product/img15.JPG";
import img16 from "../../../assets/Product/img16.jpeg";
import img17 from "../../../assets/Product/img17.JPG";
import img18 from "../../../assets/Product/img18.JPG";
import img19 from "../../../assets/Product/img19.JPG";
import img20 from "../../../assets/Product/img20.JPG";
import img21 from "../../../assets/Product/img21.JPG";
import img22 from "../../../assets/Product/img22.JPG";
import img23 from "../../../assets/Product/img23.JPG";
import img24 from "../../../assets/Product/img24.jpeg";


import { Modal } from 'react-bootstrap';
import { BsChevronLeft, BsChevronRight, BsX } from 'react-icons/bs';

import AOS from 'aos';
import 'aos/dist/aos.css';

const FullProduct = () => {
  const [showModal, setShowModal] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init({
      duration: 800,
      once: true,
    });
  }, []);

  // 24 Products Array
  const allProducts = [
    { img: img1, title: "XBA LEVER ARM", desc: "Precision-stamped lever arm designed for controlled motion in automotive mechanisms." },
    { img: img2, title: "Sullo Brkt Fr", desc: "High-strength front bracket engineered for reliable mounting support in vehicle assemblies." },
    { img: img3, title: "BRKT-SLIDE MOTOR", desc: "Precision bracket for slide motor mounting, ensuring alignment, stability, and smooth operation." },
    { img: img4, title: "MTG BRKT E4RNSS", desc: "Mounting bracket developed for secure routing and support of automotive electrical harness systems." },
    { img: img5, title: "Front Pivot", desc: "Stamped front pivot component designed to enable smooth movement in automotive assemblies." },
    { img: img6, title: "PY1B Base", desc: "Robust base component manufactured for stable mounting and distribution in automotive systems." },
    { img: img7, title: "Cushion Side Member 60P", desc: "Structural side member designed to enhance strength in automotive seating or body systems." },
    { img: img8, title: "Back Side Member RH", desc: "Right-hand side structural member engineered for  dimensional accuracy in vehicle assemblies." },
    { img: img9, title: "Backing Plate", desc: "Precision backing plate manufactured to provide reinforcement mechanical assemblies." },
    { img: img10, title: "Fan Disk", desc: "High-accuracy stamped fan disk designed for balanced rotation and efficient airflow applications." },
    { img: img11, title: "IZUZU BRACKET", desc: "Custom automotive bracket developed to meet OEM specifications for mounting structural support." },
    { img: img12, title: "DOST BASE PLate ", desc: "Stamped base plate engineered for durability, alignment, secure integration , automotive systems." },
    { img: img13, title: "Console MTG BRKT", desc: "Precision-stamped mounting bracket designed for secure console assembly in automotive interiors." },
    { img: img14, title: "DIP STICK", desc: "High-accuracy dip stick component manufactured for reliable fluid level measurement in engines." },
    { img: img15, title: "Cushoion MEMBER", desc: "Stamped structural member engineered to support cushioning systems and vibration control." },
    { img: img16, title: "BAFFEL PLATE", desc: "Durable stamped plate designed to control fluid flow, noise, or heat within automotive systems." },
    { img: img17, title: "HINGH ASSY", desc: "Precision hinge assembly ensuring smooth movement durability in automotive applications." },
    { img: img18, title: "Cushoion PLATE", desc: "Formed metal plate used in cushioning assemblies to enhance strength and load distribution." },
    { img: img19, title: "HDT HORNE UNIT", desc: "Stamped and assembled horn mounting unit designed for secure vibration resistance." },
    { img: img20, title: "HORNE PLATE", desc: "High-strength stamped plate supporting horn assemblies in automotive electrical systems." },
    { img: img21, title: "DOST LEVER ARM", desc: "Dost lever arm component designed for controlled motion and mechanical reliability." },
    { img: img22, title: "PHONix  LEVER ARM", desc: "Precision-engineered lever arm manufactured for consistent performance in automotive mechanisms." },
    { img: img23, title: "BSA LEVER  ARM", desc: "Precision-engineered lever arm manufactured for consistent performance in automotive mechanisms." },
    { img: img24, title: "PSA BASE PLATE", desc: "Base plate component manufactured to provide stable mounting and support in assemblies." }
  ];

  const handleShow = (index) => {
    setActiveIndex(index);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const handleNext = () => {
    setActiveIndex((prev) => (prev + 1) % allProducts.length);
  };

  const handlePrev = () => {
    setActiveIndex((prev) => (prev - 1 + allProducts.length) % allProducts.length);
  };

  const selectedProduct = allProducts[activeIndex];

  return (
    <section className="full-product-section">
      <Container>
        {/* HEADER */}
        <Row className="mb-5 align-items-end">
          <Col lg={6} md={12}>
            <span className="fp-label">Our Products</span>
            <h1 className="fp-heading">
              Automotive <strong>Stamped<br />Components</strong>
            </h1>
          </Col>
          <Col lg={6} md={12}>
            <p className="fp-desc ms-lg-auto">
              We manufacture a comprehensive range of precision stamped components
              designed to meet stringent automotive OEM requirements.
            </p>
          </Col>
        </Row>

        {/* PRODUCT GRID - SHOW ALL PRODUCTS */}
        <Row className="product-grid-container gy-4">
          {allProducts.map((item, index) => (
            <Col
              lg={4} md={6} sm={12}
              key={index}
              data-aos="fade-up"
              data-aos-delay={index * 100} // Incremental delay for "one by one" effect
            >
              <div
                className="fp-card"
                onClick={() => handleShow(index)}
                style={{ cursor: 'pointer' }}
              >
                <div className="fp-img-wrapper">
                  <img src={item.img} alt={item.title} className="fp-img" loading="lazy" />
                </div>
                <div className="fp-content">
                  <h3 className="fp-title">{item.title}</h3>
                  <p className="fp-text">{item.desc}</p>
                </div>
              </div>
            </Col>
          ))}
        </Row>

        {/* PAGINATION REMOVED */}

      </Container>

      {/* PRODUCT MODAL */}
      <Modal show={showModal} onHide={handleClose} centered size="xl" className="product-nav-modal">
        <Modal.Body className="p-0 position-relative">
          {/* Close Button */}
          <button className="modal-custom-close" onClick={handleClose} aria-label="Close">
            <BsX size={32} />
          </button>

          <Row className="g-0">
            {/* Left: Image Column */}
            <Col lg={6} className="modal-image-col">
              <div className="modal-image-wrapper">
                {/* Navigation Arrows integrated into image area */}
                <button className="modal-nav-arrow p-btn" onClick={handlePrev}>
                  <BsChevronLeft />
                </button>

                <img
                  src={selectedProduct?.img}
                  alt={selectedProduct?.title}
                  className="modal-main-img"
                />

                <button className="modal-nav-arrow n-btn" onClick={handleNext}>
                  <BsChevronRight />
                </button>
              </div>
            </Col>

            {/* Right: Info Column */}
            <Col lg={6} className="modal-info-col">
              <div className="modal-info-content">
                <span className="modal-category-label">Product Details</span>
                <h2 className="modal-product-title">{selectedProduct?.title}</h2>

                <p className="modal-product-desc">
                  {selectedProduct?.desc}
                </p>

                <div className="modal-footer-info">
                  <div className="product-counter-display">
                    <span className="current">{activeIndex + 1}</span>
                    <span className="separator">/</span>
                    <span className="total">{allProducts.length}</span>
                  </div>

                  <div className="modal-brand-tag">
                    Dynamic Stamping
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

    </section>
  );
};

export default FullProduct;